var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.ready)?_c('p',{staticClass:"small-text"},[_vm._v(_vm._s(_vm.time))]):_c('p',{staticClass:"small-text"},[_vm._v("Ready!")])])
}
var staticRenderFns = []

export { render, staticRenderFns }